/**
 * Borrower 档案（/app/borrowers 同页切到某人详情），菜单没有单独项。
 * 打开页面打 STATSIG.COMMON.VIEW，value=borrower。
 *
 * 从列表点姓名或邮箱进入。URL 仍是 /app/borrowers，不带 borrowerId。
 *
 * 已不算：面包屑、联系方式展示、All/Archived 切换、Stage/Status、文档区。
 * Bluerate / Consumer Connect 未加，确认后再补。
 */
export enum BorrowerEvent {
    /**
     * Create new application 的按钮交互。
     * value 与 metadata.type 相同：click_open_popup|link
     */
    CREATE_NEW_APPLICATION_BUTTON = 'BORROWER_CREATE_NEW_APPLICATION_BUTTON',
    /**
     * 档案页新建贷款真正入库。
     * value=create_manually|mismo_file
     * metadata.type=insert，metadata.method 与 value 相同
     */
    LOAN_INSERT = 'BORROWER_LOAN_INSERT',
    /**
     * 点 Import MISMO file 打开弹窗。
     * value 与 metadata.type 相同：click_open_popup
     */
    IMPORT_MISMO_FILE_BUTTON = 'BORROWER_IMPORT_MISMO_FILE_BUTTON',
    /** 点贷款卡片，进入 Loan 工作台。value 与 metadata.loan_id 相同 */
    LOAN_OPEN = 'BORROWER_LOAN_OPEN',
    /**
     * 归档 / 取消归档。
     * 属性 action=archive|unarchive
     */
    ARCHIVE = 'BORROWER_ARCHIVE',
}
